import globalCacheManager from './globalCacheManager';

const CACHE_KEY = 'item_taxon';

class ItemTaxonCache {
  constructor() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  async fetchData(forceRefresh = false) {
    if (globalCacheManager.isRefreshing) {
      return this.data || [];
    }

    if (!forceRefresh && this.data) {
      return this.data;
    }

    if (this.pendingPromise && !forceRefresh) {
      return this.pendingPromise;
    }

    this.pendingPromise = (async () => {
      try {
        await globalCacheManager.refreshFromBundle(forceRefresh);
        return this.data || [];
      } catch (error) {
        console.error('[ItemTaxonCache] Error refreshing from bundle:', error);
        return this.data || [];
      } finally {
        this.pendingPromise = null;
      }
    })();

    return this.pendingPromise;
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data || [];
    this.lastFetchTime = Date.now();
  }

  invalidate() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  getLastFetchTime() {
    return this.lastFetchTime;
  }
}

const itemTaxonCache = new ItemTaxonCache();

globalCacheManager.register(CACHE_KEY, itemTaxonCache);

export const fetchItemTaxonListCached = async (forceRefresh = false) => {
  return await itemTaxonCache.fetchData(forceRefresh);
};

export const getItemTaxonListCached = () => {
  return itemTaxonCache.getData();
};

export const invalidateItemTaxonCache = () => {
  itemTaxonCache.invalidate();
};

export default itemTaxonCache;
